function normalizeBaseUrl(baseUrl) {
  const raw = (baseUrl || '/').trim()
  if (!raw || raw === '/') return '/'
  return raw.endsWith('/') ? raw : `${raw}/`
}

function hasSuspiciousRepeatedSegments(pathname) {
  const segments = String(pathname || '')
    .split('/')
    .filter(Boolean)

  if (segments.length < 3) return false

  let repeatRun = 1
  for (let i = 1; i < segments.length; i += 1) {
    if (segments[i] === segments[i - 1]) {
      repeatRun += 1
      if (repeatRun >= 3) return true
    } else {
      repeatRun = 1
    }
  }
  return false
}

function getScopeFromManifestLink() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return null

  try {
    const manifestLink = document.querySelector('link[rel="manifest"]')
    const href = manifestLink?.getAttribute('href') || manifestLink?.href
    if (!href) return null

    // Evitar scopes contaminados por rutas de SPA cuando el href es relativo.
    // Con hofs relativos como "manifest.json", en rutas profundas puede resolverse como
    // /configuracion/configuracion/.../manifest.json y romper el SW scope.
    const isAbsoluteHref = href.startsWith('/') || /^https?:\/\//i.test(href)
    if (!isAbsoluteHref) return null

    const manifestUrl = new URL(href, document.baseURI || window.location.origin)
    const pathname = manifestUrl.pathname || '/'
    if (hasSuspiciousRepeatedSegments(pathname)) return null
    if (pathname.endsWith('/manifest.json')) {
      return normalizeBaseUrl(pathname.slice(0, -'/manifest.json'.length))
    }
    return normalizeBaseUrl(pathname.replace(/[^/]*$/, ''))
  } catch {
    return null
  }
}

export function getAppScope() {
  const envScope = normalizeBaseUrl(import.meta.env.BASE_URL)
  if (envScope && envScope !== '/') return envScope
  return getScopeFromManifestLink() || envScope || '/'
}

export function getAppBasePath() {
  const scope = getAppScope()
  if (scope === '/') return '/'
  return scope.endsWith('/') ? scope.slice(0, -1) : scope
}

/**
 * Devuelve path/scope correctos para registrar el service worker
 * respetando el BASE_URL de Vite (útil cuando la app no vive en `/`).
 */
export function getServiceWorkerConfig() {
  const scope = getAppScope()
  return {
    path: `${scope}sw.js`,
    scope
  }
}

